import querystring from "querystring";
import { Companies as CompaniesSchema } from "schemas/companies";

export interface IQuery {
    __active?: boolean;
    __at_least_one_buyer?: boolean;
    __fields?: string;
    __limit?: number;
    __search?: string;
    __sort?: string;
    __sort_order?: string;
    [filters: string]: any;
}

export const getQuery = (query: IQuery) => {
    return {
        force: true,
        schema: CompaniesSchema,
        url: `/api/v3.0/companies?${querystring.stringify(query)}`,
    };
};
